import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { theme } from "@/styles/theme";
import { media } from "@/styles/media";
import InbodyUsedItem from "./InbodyUsedItem";
import { inbodyUsedList } from "@/lib/data/inbodyUsed";

export default function InbodyUsed() {
  const { t } = useTranslation();

  return (
    <InbodyUsedWrap>
      <TitleWrap>
        <Title data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="100" data-aos-duration="500">
          {t("main.how-can-inbody-be-used")}
        </Title>
      </TitleWrap>
      <ItemWrapper>
        {inbodyUsedList.map((data, index) => {
          return <InbodyUsedItem key={index} title={data.title} bgPath={data.bgPath} href={data.href} />;
        })}
      </ItemWrapper>
    </InbodyUsedWrap>
  );
}

const InbodyUsedWrap = styled.div`
  padding: 0 32px;
  box-sizing: border-box;
`;
const TitleWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 55px 0;
  padding: 0 16px;
  box-sizing: border-box;
`;
const Title = styled.p`
  width: 100%;
  font-size: 2.7rem;
  font-weight: ${theme.fontWeights.bold};
  color: black;
  display: flex;
  ${media.tablet`
    justify-content: center;
    `}
`;
const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  ${media.tablet`
      flex-wrap: wrap;
    `}
`;
